export enum ClinicReferralType {
  RemoteMonitoringServices = 'Remote Monitoring Services',
  RemoteMonitoringServicesAndChronicCareManagement = 'Remote Monitoring Services and Chronic Care Management',
  ChronicCareManagement = 'Chronic Care Management',
  PCM = 'PCM',
  Wellness = 'Wellness',
}
